import React, { useContext, useState, useEffect } from 'react';

import SemPermissaoPanel from '../../components/sem-permissao-panel/sem-permissao-panel.jsx';
import FichaCarvao from './ficha-carvao.jsx';
import { useForm } from 'react-hook-form';
import coalService from '../../services/CoalService/coal-service.js';
import { syncCoalImages } from '../../services/CoalService/sync-coal-images.js';
import adminService from '../../services/AdminService/admin-service.js';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import PageHeaderFixed from '../../components/page-header/page-header-fixed.jsx';
import ImageViewerModal from '../../components/panel/image-viewer-modal.jsx';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { AppSettings } from '../../config/app-settings.js';

import { useTranslation } from 'react-i18next';
import { useLocation, useHistory, useParams } from 'react-router-dom';

export default function RegistroCarvao(props){
	const location = useLocation();
    const history = useHistory();
	const { user, ...settings } = useContext(AppSettings);
    const { t } = useTranslation();

	const { register, handleSubmit, watch, setValue, reset, formState: { isSubmitting, isValid } } = useForm({ mode: "onBlur" });

    const { idToken } = useParams();

    //const watchFamily = watch("family_id"); // you can supply default value as second argument

    const [ listedSites, setListedSites] = useState(null);
    const [ listedFams, setListedFams] = useState(null);
    const [ listedGens, setListedGens] = useState(null);
    const [ listedEsp, setListedEsp] = useState(null);
    const [ listedFields, setListedFields ] = useState(null);
    const [ coalImages, setCoalImages ] = useState(null);
    const [ genSearch, setGenSearch ] = useState(false);
    const [ resetTabs, setResetTabs ] = useState(false);

    const [ savedCoal, setSavedCoal ] = useState(null); //para manter o carvão e ser possivel ficar salvando ele aos poucos
    const [ newModal, setNewModal ] = useState(false);
    const [ imageModal, setImageModal ] = useState({ images: [], index: -1 });
    const [ pendingCheckedIds, setPendingCheckedIds ] = useState(null);
    const [ publishingAction, setPublishingAction ] = useState(false);
    const [ imageProgress, setImageProgress ] = useState(null); // { atual, total } enquanto as fotos são enviadas
    const [ pendingRemovals, setPendingRemovals ] = useState([]); // remoções de foto que falharam e que o próximo "Salvar" deve repetir

    // Callback version of watch.  It's your responsibility to unsubscribe when done.
    React.useEffect(() => {
        const subscription = watch((value, {name}) => {
            if(name == "family_id"){
                if(value.family_id == 0){ //Caso esteja selecionando nenhuma família agora, recarrega todos os gêneros e famílias e limpa as espécies
                    setListedGens(null);
                    register('species_id', { value: 0 });
                    setValue('species_id', 0);
                    adminService.getGenus().then(
                        response => {
                            setListedGens([...response.data])
                        }
                    )
                    setListedEsp(null);
                } else {  
                    if(value.genus_id == 0){//No caso de escolher primeiro o dropdown de família
                        setListedGens(null);
                        adminService.listSpeciesByFamily(value.family_id).then(
                            response => {
                                setListedEsp([...response.data]);
                            }
                        )
                        adminService.listGenusByFamily(value.family_id).then(
                            response => {
                                setListedGens([...response.data]);
                            }
                        )
                    }else {//ou de a familia recarregar ao escolher o genero
                        adminService.getFamilyByGenusId(value.genus_id).then(
                            response => {
                                if(response.data[0].id != value.family_id){
                                    setListedGens(null);
                                    register('species_id', { value: 0 });
                                    setValue('species_id', 0);
                                    register('genus_id', { value: 0 });
                                    setValue('genus_id', 0);
                                    adminService.listSpeciesByFamily(value.family_id).then(
                                        response => {
                                            setListedEsp([...response.data]);
                                        }
                                    )
                                    adminService.listGenusByFamily(value.family_id).then(
                                        response => {
                                            setListedGens([...response.data]);
                                        }
                                    )
                                }
                            }
                        )
                    }
                }
            }else if( name == "genus_id" ){
                if( value.genus_id == 0){ //Está selecionando nenhum gênero, tem q limpar a seleção de espécie
                    if(value.species_id != 0){
                        adminService.listSpeciesByFamily(value.family_id).then(
                            response => {
                                setListedEsp([...response.data]);
                                register('species_id', { value: 0 });
                                setValue('species_id', 0);
                            }
                        )
                    }                    
                }else{
                    if(value.family_id == 0){ //Esse é o caso de escolher o dropdown de genero antes do dropdown de familia.
                        adminService.getFamilyByGenusId(value.genus_id).then(
                            response => {
                                register('family_id', { value: response.data[0].id });
                                setValue('family_id', response.data[0].id);
                            }
                        )
                    }
                    adminService.listSpeciesByGenus(value.genus_id).then(
                        response => {
                            setListedEsp([...response.data])
                        }
                    )
                } 
                
            }else if ( name == "species_id" ){ //Aqui é quando a família é escolhida primeiro, e então a espécie.
                if(value.genus_id == 0){
                    adminService.getGenusBySpeciesId(value.species_id).then(
                        response => {
                            setListedGens([...response.data])
                            register('genus_id', { value: response.data[0].id });
                            setValue('genus_id', response.data[0].id);
                        }
                    )
                }
            }
        });

        return () => {subscription.unsubscribe();};
    }, [watch]);

    // Para o botão "Novo"
    const toggleModal = (name) => {
		if(name === 'new') setNewModal(!newModal);
	}

    const newRegister = (data) => {
        setNewModal(true);
    }

    // Limpa as fotos ao começar um registro novo (o reset() não limpa, elas ficam no estado da ficha).
    // A fila antes das fotos: o efeito da ficha que reage às fotos lê a fila de remoção.
    const clearImages = () => {
        setPendingRemovals([]);
        setCoalImages([]);
    }

    const continueNewRegister = (data) => {
        setResetTabs(true);
        if(genSearch == false){
            setListedGens(null);
            adminService.getGenus().then(
                response => {
                    setListedGens([...response.data])
                }
            )
            setListedEsp(null);
            setSavedCoal(null);
            clearImages();
            reset();
            toggleModal('new');
        }else{
            if(!data.species_id){
                data.species_id = "0";
            }
            history.push({pathname: '/pesquisa', state: {searchData : data}, from: '/novo-registro'});
        }
    }

    const goPublic = async (data) => {
        setPublishingAction(true);
        const saved = await saveRegister(data); // salva o registro antes de publicar e aguarda terminar
        // não publica se algo falhou (inclusive foto que não subiu): o usuário corrige e tenta de novo
        if (!saved) { setPublishingAction(false); return; }
        const id = savedCoal?.id;
        if (!id) { setPublishingAction(false); return; } // se não tiver id, desativa o spinner e para

        const response = await coalService.publishCoal(id); // chama a API para publicar
        if (response.status === 200) {
            setSavedCoal(prev => ({ ...prev, status: 2 }));
            settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('carvão.result.botão.alerta.registroPublicado'));
        }
        setPublishingAction(false); // desativa o spinner
    }

    const goPrivate = async () => {
        setPublishingAction(true);// ativa o spinner do botão de privar
        const response = await coalService.unpublishCoal(savedCoal.id); // chama a API para privar
        if (response.status === 200) {
            setSavedCoal(prev => ({ ...prev, status: 1 }));
            settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('carvão.result.botão.alerta.registroPrivado'));
        }
        setPublishingAction(false);
    }

    const generateSearch = (data) => {
        setNewModal(true);
        setGenSearch(true);
    }

    /**
     * Aplica no servidor as fotos novas e removidas de uma ficha já salva, uma foto por requisição.
     * A lista que volta (com id nas fotos enviadas e status de erro nas que falharam) substitui a da tela,
     * e as remoções que falharam voltam para a fila de remoção da ficha, para o próximo "Salvar" repeti-las.
     * @returns {Promise<{failed: number, rejected: number}>} quantas operações falharam e, entre os envios,
     * quantos o servidor recusou (só se resolvem removendo a foto)
     */
    const syncImages = async (coalId, images, removedImages) => {
        if(!removedImages.length && images.every(image => image.status === 'saved')) return { failed: 0, rejected: 0 };

        try{
            const result = await syncCoalImages(coalId, images, removedImages, (atual, total) => setImageProgress({ atual, total }));
            // a fila primeiro: o efeito da ficha que reage à nova lista de fotos lê as remoções pendentes
            // (no React 17, setState depois de um await não é agrupado, então a ordem importa)
            setPendingRemovals(result.failedRemovals);
            setCoalImages(result.items);
            return { failed: result.failed, rejected: result.rejected };
        }finally{
            setImageProgress(null);
        }
    }

    // A ficha foi salva, mas alguma foto não: fica na tela para o usuário ver os selos, e os fluxos
    // que limpam a ficha ("salvar e novo", "gerar pesquisa") não seguem. Foto recusada pelo servidor
    // não se resolve com um novo Salvar, então o texto manda removê-la.
    const handleImageFailure = ({ failed, rejected }) => {
        setNewModal(false);
        setGenSearch(false);
        settings.handleSetAlert('danger', t('alerta.titulo.erro'), rejected > 0
            ? t('imagens.alerta.fotoRecusada', { quantidade: rejected })
            : t('imagens.alerta.falhaEnvio', { quantidade: failed }));
    }

    /**
     * Para o botão "Salvar": salva a ficha e depois aplica as fotos, uma por requisição.
     * @returns {Promise<boolean|undefined>|undefined} true: ficha e fotos salvas; false: ficha salva,
     * mas alguma foto falhou; undefined: ficha não salva (validação barrou, ou a requisição da ficha falhou).
     * O goPublic só publica com true.
     */
    const saveRegister = (data) => {
        setResetTabs(true);
        if(data.type == 0){
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('carvão.registro.alerta.selecioneCategoria'));
            return;
        }
        if(data.family_id != 0 || data.determination != ''){
            // as fotos vão por rota própria (uma por requisição), então saem do corpo da ficha
            const images = data.images || [];
            const removedImages = data.removedImages || [];
            delete data.images;
            delete data.removedImages;

            // ids dos checkboxes marcados; o back monta o chars a partir deles
            data.checked_ids = Object.entries(data.charsAr || {})
                .filter(([, marcado]) => marcado)
                .map(([id]) => Number(id));

            let observations = {};
            for(let text in data.texts){
                observations[text] = data.texts[text];
            }

            data.observations = observations;
            delete data.texts;

            //caso não seja o primeiro save
            if(!savedCoal){
                return coalService.registerCoal(data).then(async (response)=>{
                    // a ficha já existe: guarda o registro antes das fotos, para o próximo "Salvar" atualizar em vez de criar outra
                    setSavedCoal(response.data);
                    const sync = await syncImages(response.data.id, images, removedImages);
                    if(sync.failed){
                        handleImageFailure(sync);
                        return false;
                    }

                    settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('carvão.registro.alerta.registroCriado'));
                    if(newModal != false){
                        if(genSearch == false){
                            setSavedCoal(null);
                            clearImages();
                            reset();
                            toggleModal('new');
                        }else{
                            continueNewRegister(data);
                        }
                    }
                    return true;
                }).catch((err)=>{
                    console.log(err);
                    settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
                })
            }else{
                return coalService.updateCoal(data, savedCoal.id).then(async (response)=>{
                    if(newModal == false){
                        setSavedCoal(response.data);
                    }
                    const sync = await syncImages(savedCoal.id, images, removedImages);
                    if(sync.failed){
                        handleImageFailure(sync);
                        return false;
                    }

                    settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('carvão.registro.alerta.registroAtualizado'));
                    if(newModal != false){
                        continueNewRegister(response.data);
                    }
                    return true;
                }).catch((err)=>{
                    console.log(err);
                    settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
                })
            }
            
        }else{
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('Por favor selecione ou preencha pelo menos uma classificação taxonômica.'));
            return;
        }
    }

    useEffect(() => {
        if(!listedFields || !pendingCheckedIds) return;

        pendingCheckedIds.forEach((id) => setValue('charsAr.' + id, true));

        setPendingCheckedIds(null);
    }, [listedFields, pendingCheckedIds]);

    useEffect(() => {
        // acontece quando o componente é montado
        let _isMounted = true;

        coalService.getAllSites().then(
            response => {
                if(_isMounted && (response.data.length > 0)){
                    setListedSites(response.data);
                }
            }
        )

        adminService.listAllFamilies().then(
            response => {
                if(_isMounted){
                    setListedFams([...response.data]);
                }
            }
        )

        adminService.getGenus().then(
            response => {
                if(_isMounted){
                    setListedGens([...response.data]);
                }
            }
        )

        const loadCoal = (coal) => {
            setSavedCoal(coal);

            coal.observations = coal.observations || [];
            coal.images = coal.images || [];
            coal.family_id = coal.family_id ?? "0";
            coal.genus_id = coal.genus_id ?? "0";
            coal.species_id = coal.species_id ?? "0";
            coal.site_id = coal.site_id ?? 0;
            coal.sub_fam = coal.sub_fam ?? "";
            coal.determination = coal.determination ?? "";
            coal.origin = coal.origin ?? "";
            coal.code = coal.code ?? "";
            coal.locale = coal.locale ?? "";
            coal.type = coal.type ?? 0;

            if(coal.family_id == "0"){ // Começa checando se n tem uma família selecionada       
                adminService.listAllFamilies().then(
                    response => {
                        if(_isMounted){
                            setListedFams([...response.data]);
                        }
                    }
                )
                adminService.getGenus().then(
                    response => {
                        if(_isMounted){
                            setListedGens([...response.data]);
                        }
                    }
                )
            }else if(coal.genus_id == "0"){  // Se tiver, checa se n tem um genero
                setValue('family_id', coal.family_id);
                adminService.listSpeciesByFamily(coal.family_id).then(
                    response => {
                        setListedEsp([...response.data]);
                    }
                )
                adminService.listGenusByFamily(coal.family_id).then(
                    response => {
                        setListedGens([...response.data]);
                    }
                )
            }else if(coal.species_id == "0"){ //se tiver, checa se n tem uma espécie
                setValue('genus_id', coal.genus_id);
                setValue('family_id', coal.family_id);
                adminService.listSpeciesByGenus(coal.genus_id).then(
                    response => {
                        setListedEsp([...response.data]);
                    }
                )
                adminService.listGenusByFamily(coal.family_id).then(
                    response => {
                        setListedGens([...response.data]);
                    }
                )
            }else{
                setValue('species_id', coal.species_id);
                setValue('genus_id', coal.genus_id);
                setValue('family_id', coal.family_id);
            }
            
            if(coal.sub_fam != ""){
                setValue('sub_fam', coal.sub_fam);
            }
            if(coal.determination != ""){
                setValue('determination', coal.determination);
            }
            if(coal.origin != ""){
                setValue('origin', coal.origin);
            }
            if(coal.site_id != 0){
                setValue('site_id', coal.site_id);
            }
            if(coal.code != ""){
                setValue('code', coal.code);
            }
            if(coal.locale != ""){
                setValue('locale', coal.locale);
            }
            if(coal.type != 0){
                setValue('type', coal.type);
            }

            // Essa é a parte responsável por marcar as checkboxes
            setPendingCheckedIds(coal.checked_ids || []);

            // Preenche os campos de texto
            coal.observations.map((observation) => {
                setValue('texts.'+observation.fields_id, observation.text);
            });
            
            setCoalImages(coal.images.map(image => ({ key: 'img-' + image.id, id: image.id, photo: image.photo, status: 'saved' })));
        }

        if(location.from){
            loadCoal(location.state.searchData);
        } else if(idToken != null){
            // busca direto da API na nova guia
            coalService.getInfoCoal(idToken).then(response => {
                if(_isMounted) loadCoal(response.data);
            }).catch((err) => {
                console.log('ERRO getInfoCoal:', err);
                history.push('/404');
            });
        }

		//acontece quando o componente é desmontado
		return () => {
			_isMounted = false;
		}
	}, [])

    if(user === null){
        return(
            <div className="fa-3x carregando-pagina">
                <i className="fas fa-spinner fa-pulse"></i>
            </div>
        )
    }
    else if(!user){
        return(
            <SemPermissaoPanel/>
        )
    }else{
        return(<>
            <form onSubmit={handleSubmit(newRegister)}>
                <PageHeaderFixed
                    title={savedCoal != null ? t('carvão.edição.titulo') : t('carvão.registro.botão.novoRegistro')}
                    rowClassName="h-auto"
                    actions={
                        <>
                            <div>
                                <button type="submit" onClick={handleSubmit(newRegister)}
                                    className="btn btn-primary d-block w-100 btn-lg fs-13px text-nowrap" >
                                        {t('carvão.registro.botão.novoRegistro')}
                                </button>
                            </div>
                            <div>
                                <button type="submit" onClick={handleSubmit(saveRegister)}
                                    disabled={publishingAction || isSubmitting || !isValid} className="btn btn-success d-block w-100 btn-lg fs-13px text-nowrap">
                                        {(isSubmitting && !publishingAction) && (<i className="fas fa-spinner fa-pulse m-2"></i>)}
                                        {t('carvão.registro.botão.salvarRegistro')}
                                </button>
                                {imageProgress && <div className="fs-12px text-center mt-1">{t('imagens.progresso', { atual: imageProgress.atual, total: imageProgress.total })}</div>}
                            </div>
                            {savedCoal && (
                                <div>
                                    <button type="button"
                                        onClick={savedCoal.status === 2 ? goPrivate : handleSubmit(goPublic)}
                                        disabled={publishingAction || isSubmitting}
                                        className={`btn d-block w-100 btn-lg fs-13px text-nowrap ${savedCoal.status === 2 ? 'btn-warning' : 'btn-success'}`}>
                                            {publishingAction && (<i className="fas fa-spinner fa-pulse m-2"></i>)}
                                            {savedCoal.status === 2 ? t('carvão.result.botão.privar') : t('carvão.registro.botão.publicar')}
                                    </button>
                                </div>
                            )}
                            <div>
                                <button type="submit" onClick={handleSubmit(generateSearch)}
                                    className="btn btn-success d-block w-100 btn-lg fs-13px text-nowrap" >
                                        {t('carvão.registro.botão.gerarPesquisa')}
                                </button>
                            </div>
                        </>
                    }>
                    <div className='col'>
                        <Panel className="mb-2">
                            <PanelHeader className="pt-1 pb-1" noButton={true}>
                                <div className="d-flex align-items-center">                                       
                                    <select name="type" className="col form-select form-select-floating-compact w-auto" id="nome" {...register('type')} >
                                        <option value='0'>{t('carvão.dropdown.categoria.selecioneCategoria')}</option>
                                        <option value='1'>{t('carvão.dropdown.categoria.arqueologicos')}</option>
                                        <option value='2'>{t('carvão.dropdown.categoria.lenhosReferencia')}</option>
                                        <option value='3'>{t('carvão.dropdown.categoria.literatura')}</option>
                                    </select>      

                                    <div className="col-5 flex-grow-1"></div>                       
                                </div>                                        
                            </PanelHeader>
                            <PanelBody className="mb-n2">
                                <div className='row mb-1'>                              
                                    <div className='col d-flex align-items-center'>
                                        <div className="form mb-1 w-100">
                                            {
                                                listedFams === null && <i className="fas fa-spinner fa-pulse"></i>
                                            }
                                            {
                                                listedFams &&
                                                <select name="family_id" className="form-select form-select-floating-compact fs-12px fw-lighter" id="family_id" {...register('family_id')}>
                                                    <option value='0'>{t('carvão.dropdown.selecioneFamília')}</option>
                                                    {
                                                        listedFams.map((u)=> <option key={u.id} value={u.id}>{u.name}</option>)
                                                    }
                                                </select>
                                            }
                                        </div>   
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating form-floating-compact">
                                            <input name="sub_fam" type="text" className="form-control fs-12px fw-lighter" placeholder={t('carvão.subFamilia')} id="sub_fam" {...register('sub_fam')}/>
                                            <label className="d-flex align-items-center fs-12px text-gray-500">{t('carvão.subFamilia')}</label>
                                        </div> 
                                    </div>
                                    <div className='col d-flex align-items-center'>
                                        <div className="form mb-1 w-100">
                                            {
                                                listedGens === null && <i className="fas fa-spinner fa-pulse"></i>
                                            }
                                            {
                                                listedGens &&
                                                <select name="genus_id" className="form-select form-select-floating-compact fs-12px fw-lighter" id="genus_id" {...register('genus_id')}>
                                                    <option value='0'>{t('carvão.dropdown.selecioneGênero')}</option>
                                                    {
                                                        listedGens.map((u)=> <option key={u.id} value={u.id}>{u.name}</option>)
                                                    }
                                                </select>
                                            }
                                        </div> 
                                    </div>
                                    <div className='col'>
                                        <div className="form">
                                            {
                                                listedEsp === null &&
                                                <select className="form-select form-select-floating-compact fs-12px fw-lighter">
                                                    <option value='0'>{t('carvão.dropdown.selecioneFamíliaOuGênero')}</option>
                                                </select>
                                            }
                                            {
                                                listedEsp &&
                                                <select name="species_id" className="form-select form-select-floating-compact fs-12px fw-lighter" id="species_id" {...register('species_id')}>
                                                    <option value='0'>{t('carvão.dropdown.selecioneEspécie')}</option>
                                                    {
                                                        listedEsp.map((u)=> <option key={u.id} value={u.id}>{u.name}</option>)
                                                    }
                                                </select>
                                            }
                                        </div> 
                                    </div>
                                    <div className='col-4'>
                                        <div className="form-floating form-floating-compact">
                                            <input name="determination" type="text" className="form-control fs-12px fw-lighter" placeholder={t('carvão.determinação')} id="determination" {...register('determination')}/>
                                            <label className="d-flex align-items-center fs-12px text-gray-500">{t('carvão.determinação')}</label>
                                        </div>                                        
                                    </div>
                                </div>
                                <div className='row mb-1'>
                                    <div className='col-5'>
                                        <div className="form-floating form-floating-compact">
                                            <input name="origin" type="text" className="form-control fs-12px fw-lighter" placeholder={t('carvão.procedência')} id="origin" {...register('origin')}/>
                                            <label className="d-flex align-items-center fs-12px text-gray-500">{t('carvão.procedência')}</label>
                                        </div>                                        
                                    </div>
                                    <div className='col d-flex align-items-center'>
                                        <div className="form mb-1 w-100">
                                            {
                                                listedSites === null && <i className="fas fa-spinner fa-pulse"></i>
                                            }
                                            {
                                                listedSites &&                                                
                                                <select name="site_id" className="form-select form-select-floating-compact fs-12px fw-lighter" id="site_id" {...register('site_id')}>
                                                    <option value="0">{t('carvão.dropdown.selecioneSítio')}</option>
                                                    {
                                                        listedSites.map((u)=> <option key={u.id} value={u.id}>{u.name}</option>)
                                                    }
                                                </select>
                                            }
                                        </div>  
                                    </div>                                  
                                    <div className='col-2'>
                                        <div className="form-floating form-floating-compact">
                                            <input name="code" type="text" className="form-control fs-12px fw-lighter" placeholder={t('carvão.código')} id="code" {...register('code')}/>
                                            <label className="d-flex align-items-center fs-12px text-gray-500">{t('carvão.código')}</label>
                                        </div>                                        
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating form-floating-compact">
                                            <input name="locale" type="text" className="form-control fs-12px fw-lighter" placeholder={t('carvão.localização')} id="locale" {...register('locale')}/>
                                            <label className="d-flex align-items-center fs-12px text-gray-500">{t('carvão.localização')}</label>
                                        </div>                                        
                                    </div>
                                </div>
                            </PanelBody>
                        </Panel>
                    </div> 
                    <FichaCarvao register={register} setValue={setValue} setListedFields={setListedFields} textFields={true} setImageModal={setImageModal} coalImages={coalImages} pendingRemovals={pendingRemovals} imagesLocked={isSubmitting} resetTabs={resetTabs} setResetTabs={setResetTabs} settings={settings}/>

                    <Modal isOpen={newModal} toggle={() => toggleModal('new')}>
                        <ModalHeader 
                            toggle={() => toggleModal('new')} 
                            close={
                                <button className="btn-close" onClick={() => toggleModal('new')}></button>
                            }>
                                <i className="fa fa-circle-exclamation"></i> {t('modal.atenção')}
                        </ModalHeader>    
                        
                        <ModalBody>
                            <div className="alert mb-0 fs-5">
                                <p>{t('carvão.registro.modal.novoRegistro.textoAviso1')}</p>
                                <p>{t('carvão.registro.modal.novoRegistro.textoAviso2')}</p>
                            </div>
                        </ModalBody>
                        
                        <ModalFooter>
                            <button className="btn btn-secondary" onClick={() => toggleModal('new')}>{t('botão.cancelar')}</button>
                            <button className="btn btn-primary" type="submit" onClick={handleSubmit(continueNewRegister)} >
                            {t('botão.continuar')}</button>
                            <button className="btn btn-success" type="submit" onClick={handleSubmit(saveRegister)} disabled={isSubmitting} >
                            {t('carvão.registro.modal.novoRegistro.salvarContinuar')}</button>
                        </ModalFooter>
                    </Modal>

                    <ImageViewerModal images={imageModal.images} startIndex={imageModal.index} isOpen={imageModal.index >= 0} onClose={() => setImageModal(m => ({ ...m, index: -1 }))} /> 
                </PageHeaderFixed>
            </form>
        </>)
    }
}
